import React from 'react'
import Navbar from '../Navbar';
import Eventbody from "./Eventsbody";

function Events() {
  return (
    <div>
      
        {/* <Navbar /> */}
        
        <Eventbody />
    </div>
  )
}

export default Events